var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessagesquestion1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/messages question 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.98456 14.4354C9.61643 14.441 11.2502 13.756 12.414 12.3752C14.1554 10.3094 14.2102 7.20946 12.5379 5.08747C10.3608 2.32412 6.3396 2.15114 3.93098 4.5679C2.17026 6.33395 1.78999 8.95052 2.77647 11.0907C2.85862 11.2961 3.17666 11.8607 3.39013 12.2322C3.5115 12.4433 3.49905 12.7037 3.35901 12.9023C3.21835 13.1009 3.04036 13.3551 2.90157 13.5636C2.65323 13.9364 2.91713 14.436 3.36399 14.4354L3.71045 14.4353C5.23 14.4346 7.45508 14.4337 7.98456 14.4354Z",
    stroke: "#9E9BAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.85626 11.1265V11.131",
    stroke: "#9E9BAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.85533 9.68731C7.84848 9.16213 8.32464 8.93915 8.67939 8.73621C9.11069 8.49762 9.40381 8.11733 9.40381 7.58965C9.40381 6.80779 8.77334 6.18018 7.99913 6.18018C7.21987 6.18018 6.59503 6.80779 6.59503 7.58965",
    stroke: "#9E9BAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesquestion1);
export default __webpack_public_path__ + "static/media/messages question 1.e0e312e13e75a23798be96cf8d3c6a50.svg";
export { ForwardRef as ReactComponent };